<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>QR Code</h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                <v-layout row wrap>
                  <v-flex xs6 lg4>
                    <v-btn color="#077893" outlined to="/qrcode-add">
                      <v-icon class="mr-1">mdi-plus</v-icon>เพิ่มข้อมูล QR Code
                    </v-btn>
                    <br />
                    <br />
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex d-flex justify-end lg4>
                    <v-text-field
                      color="#077893"
                      append-icon="mdi-magnify"
                      v-model="Search"
                      outlined
                      clearable
                      :label="$t('consentlist.search')"
                      type="text"
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-layout row wrap justify-center align-center>
                <v-flex lg12>
                  <v-data-table
                    :search="Search"
                    :loading="tableload"
                    :loading-text="$t('overlay.load')"
                    :headers="headers"
                    :items="AllService"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    hide-default-footer
                    @page-count="pageCount = $event"
                  >
                    <template v-slot:[`item.Type`]="{ item }">
                      <div v-if="item.Type === 'Group'">
                        {{ $t("dashboard.groupType") }}
                      </div>
                      <div v-else-if="item.Type === 'General'">
                        {{ $t("dashboard.generalType") }}
                      </div>
                    </template>
                    <template v-slot:[`item.NameTh`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.NameTh }}
                      </div>
                      <div v-else>{{ item.NameEng }}</div>
                    </template>
                    <template v-slot:[`item.UpdatdeAt`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.UpdatdeAt }}
                      </div>
                      <div v-else>
                        {{ item.UpdatdeAtEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-btn
                        color="#077893"
                        outlined
                        @click="Fn_Detail(item)"
                        >{{ $t("consentlist.detail") }}</v-btn
                      >
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12>
                  <div class="text-center pt-2">
                    <v-pagination
                      :total-visible="7"
                      class="pt-2 pb-2"
                      circle
                      color="#077893"
                      v-model="page"
                      :length="pageCount"
                      prev-icon="mdi-menu-left"
                      next-icon="mdi-menu-right"
                    >
                    </v-pagination>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <DialogCookiesDelete
        :show="DialogCookiesDelete"
        :_item="ItemDelete"
        @closeDialogDelete="DialogCookiesDelete = false"
        @reData="GetAllService()"
      />
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import DialogCookiesDelete from "@/components/dialog/DialogCookiesDelete";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
// import authorization from "@/functions/authorization.js";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogCookiesDelete, OverlaySearch },
  data: function () {
    return {
      Search: "",
      ItemDelete: [],
      loadingDownloadData: false,
      itemsAction: [
        {
          icon: "mdi-refresh-circle",
          text: "รีเฟรช",
          text2: "Refresh",
          color: "info",
          service: "Refresh",
        },
        {
          icon: "mdi-text-box-search",
          text: "ดูรายละเอียด",
          text2: "Preview",
          color: "success",
          service: "Preview",
        },
      ],
      AllService: [],
      DialogCookiesDelete: false,
      DialogDelete: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      tableload: false,
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    ...mapGetters(["Profile"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    _SelectTaxId: {
      
      get() {
        return this.Business.TaxId || "-";
      },
    },

    headers() {
      return [
        {
          text: "ชื่อ QR Code",
          align: "center",
          value: "QrcodeName",
          width: "20%",
          sortable: false,
        },
        {
          text: "ประเภท",
          value: "Type",
          align: "center",
          width: "20%",
          sortable: false,
        },
        {
          text: this.$i18n.t("mcg.row3"),
          align: "center",
          value: "NameTh",
          width: "20%",
          sortable: false,
        },
        {
          text: this.$i18n.t("onechat.date"),
          align: "center",
          value: "UpdatdeAt",
          width: "20%",
          sortable: false,
        },
        {
          text: this.$i18n.t("policyForm.select"),
          value: "action",
          sortable: false,
          width: "20%",
          align: "center",
        },
      ];
    },
  },
  companyth: {
    get() {
      if (this.$i18n.locale === "th") {
        return this.profile.name_on_document_th;
      } else {
        return this.profile.name_on_document_eng;
      }
    },
  },
  mounted() {
    this.GetAllService();
  },
  methods: {
    fn_checkActionType(val, item) {
      if (val == "Refresh") {
        this.Fn_Refresh(item);
      } else if (val == "Preview") {
        this.Fn_Detail(item);
      }
    },
    async GetAllService() {
      this.loadingDownloadData = true;
      this.tableload = true;
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: this.$cookies.get("BusinessId"),
      };
      // var Headers = {
      //   AccountId: this.$cookies.get("OneAccountId"),
      // };
      // var dataEncode = await authorization.encodeDataNew(payload);
      // var auth = await authorization.encodeDataNew(Headers);
      // var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "qrcode/GetQrcodeAll",
          // { Data: dataEncode },
          // { headers }
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false;
          this.tableload = false;
          if (response.data.Status === "OK") {
            this.AllService = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          this.tableload = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Detail(item) {
      this.$cookies.set("QrcodeId", item.Id);
      this.$router.push({ path: "/qrcode-detail" });
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.blurry-text {
  font-size: 14px;
  color: transparent;
  text-shadow: 0 0 8px #000;
}

.textcolor {
  color: #077893;
}

.v-progress-circular {
  margin: 1rem;
}

.yellow {
  color: yellow;
}

.green {
  color: green;
}

.red {
  color: red;
}
</style>
